import React, { useState } from 'react';
import {
  Button,
  FormControl,
  FormLabel,
  MenuItem,
  Select,
} from '@material-ui/core';

import {
  AvailableExamFormGradesForType,
  ExamFormGrade,
  ExamFormGrades,
  ExamFormType,
} from '../types';

interface ExamFormEntryGradeSelectorProps {
  examFormEntryType: ExamFormType;
  onSubmit: (grade: ExamFormGrade) => void;
}

const ExamFormEntryGradeSelector = (props: ExamFormEntryGradeSelectorProps) => {
  const [selectedGrade, setSelectedGrade] = useState<ExamFormGrade | null>(
    null,
  );

  const handleSelect = (
    event: React.ChangeEvent<{ name?: string; value: unknown }>,
  ) => {
    setSelectedGrade(event.target.value as ExamFormGrade);
  };

  const handleSubmit = () => {
    if (selectedGrade === null) {
      return;
    }

    props.onSubmit(selectedGrade);
  };

  return (
    <>
      <FormControl>
        <FormLabel id="valuation-select-label">Beoordeel verslag</FormLabel>
        <Select
          labelId="valuation-select-label"
          id="valuation-select"
          value={selectedGrade || '-'}
          name="valuation"
          onChange={handleSelect}
          MenuProps={{ elevation: 1 }}
          displayEmpty
        >
          <MenuItem value="-">
            <i>Maak een keuze</i>
          </MenuItem>
          {AvailableExamFormGradesForType[props.examFormEntryType].map(
            (grade) => (
              <MenuItem key={grade} value={grade}>
                {ExamFormGrades[grade]}
              </MenuItem>
            ),
          )}
        </Select>
      </FormControl>
      <div>
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          Opslaan
        </Button>
      </div>
    </>
  );
};

export default ExamFormEntryGradeSelector;
